
import React, { useState } from "react";
import {
  Button,
  PageHeader,
  Row,
  Col,
  Tag,
  Typography,
  List,
  Modal,
  Tooltip,
  Badge,
  Popover,
  Alert,
  message,
  Popconfirm,
  Spin,
  Avatar
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  InfoCircleOutlined,
  ExportOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FieldTimeOutlined,
  SendOutlined,
  SyncOutlined,
  IdcardOutlined,
  CopyOutlined,
  ShareAltOutlined,
  BookOutlined,
  TruckOutlined,
  GiftOutlined
} from "@ant-design/icons";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import Marquee from "react-fast-marquee";

import {
  deleteGiftSubscription
} from "./../../services";

const { Paragraph, Title } = Typography;

const { confirm } = Modal;

const RETURN_LABEL_CHECK = [
  "Return in person",
  "Create return Label",
  "Return In Transit",
  "Return Received",
];
// const RETURN_LABEL_CHECK = ["Received","In Transit"];

const Content = ({ children, extraContent }) => (
  <Row>
    <div className="image">{extraContent}</div>
    <div
      style={{
        flex: 2,
      }}
    >
      {children}
    </div>
  </Row>
);

const MyParagraphView = ({ data }) => {
  return (
    <Paragraph>
      {Object.entries(data).map(([key, value]) => (
        <span key={key}>
          <strong>{`${key}: `}</strong>
          {value}
          <br />
        </span>
      ))}
    </Paragraph>
  );
};




const getData = (myData, keysToInclude) => {
  const filteredData = Object.fromEntries(
    Object.entries(myData).filter(([key]) => keysToInclude.includes(key))
  );

  // Convert filtered data to the desired format
  const transformedData = Object.entries(filteredData).map(([key, value]) => ({
    label: key,
    value: value,
  }));

  return transformedData;
};

const objEmpty = async (test) => {
  return test && typeof test === "object" && Object.keys(test).length > 0;
};

const StripeGifts = (props) => {

  const [loading, setLoading] = useState(false);

  const copyCouponCode = () => {
    const { coupon_info } = props;

    navigator.clipboard.writeText(coupon_info.id);

    message.success("Coupon Code Copied.");
  };

  const deleteGiftFunc = async() => {
    const { coupon_info } = props;

    const loadingKey = "couponKey";
    message.loading({ content: 'Action in progress..', loadingKey });

    const giftResp =   await deleteGiftSubscription({coupon_id:coupon_info?.id});
     console.log(giftResp);

    if(giftResp.status="success"){
      message.success({ content: giftResp.message, loadingKey, duration: 2 });
    } else {
      message.warning({ content: "Something Went Wrong :(", loadingKey, duration: 2 });
    }

  };

 

  const shareCoupon = () =>{

    props.shareCouponFunc (coupon_info);

    console.log(coupon_info);
  
  };

  const { coupon_info, is_redeemed,checkout_info } = props;

  const {total_details} = checkout_info;


  // const durationInSeconds =
  //   subscription.current_period_end - subscription.current_period_start;
  // const durationInDays = moment.duration(durationInSeconds, "seconds").asDays();

  // console.log(startDate, endDate, durationInDays);

  const subscription_info = (
    <div>
      <div>
        You may continue using the Aletheia sensor until the end of the current
        subscription period.
      </div>
      <div>
        Please return your sensor within 1 week of the end of your subscription
        period to avoid additional charges.
      </div>
      <div>
        <b>Valid until #DATE</b>
      </div>
    </div>
  );

  return (
    // <Badge.Ribbon text="TRIAL PERIOD"  placement={"start"}>
    <PageHeader
      style={{ boxShadow: "0 0 1.5em #ccc", borderRadius: "20px" }}
      title={"Gift Subscription"}
      className="site-page-header"
      tags={
        props.is_redeemed == true ? (
          <Tag color="green">Redeemed</Tag>
        ) : props.status === "canceled" ? (
          <Tag color="orange">Not Redeemed</Tag>
        ) : (
          <Tag color="orange">Not Redeemed</Tag>
        )
      }
      extra={[
        <>
          <Tooltip title="Copy Coupon ID">
            <Button
              key="3"
              shape="round"
              size="default"
              icon={<CopyOutlined />}
              // onClick={() => props.updateSub("order",props)}
              onClick={copyCouponCode}
            />
          </Tooltip>

          <Tooltip title="Share the coupon code via email.">
            <Button
              key="3"
              shape="round"
              size="default"
              icon={<ShareAltOutlined />}
              // onClick={() => props.updateSub("order",props)}
              onClick={shareCoupon}
            />
          </Tooltip>

          {props.is_redeemed == true ? (
          
            

              <Popconfirm placement="top" title={"Are you sure to Cancel this Subscription? "} onConfirm={deleteGiftFunc} okText="Yes" cancelText="No">

      
              <Button
                key="1"
                shape="round"
                type="danger"
                size="default"
                icon={<DeleteOutlined />}
              />
              </Popconfirm>
           
          ) : (
            ""
          )}
        </>,
      ]}
      avatar={
      {
        src:<Avatar
        style={{ backgroundColor: "#fa9e24" }}
        icon={<GiftOutlined />}
      />
      }
      } 
    >
      <Content>
        <List size="small">
          <List.Item>
            <Row>
              <Col span={12}>
                <Typography.Text>
                  <b>Coupon Code</b>
                </Typography.Text>
                :
                <div>
                  <Title>
                    {" "}
                    {coupon_info.id}{" "}
                    <span
                      style={{
                        display: "contents",
                        fontSize: "18px",
                        color: "#000",
                      }}
                    >
                      <Typography.Text>
                        <b>Discount</b>
                      </Typography.Text>
                      : 100 % Off
                    </span>
                  </Title>
                </div>
              </Col>{" "}
              <Col span={6}>
                {" "}
                <Typography.Text>
                  <b>Gift Amount</b>
                </Typography.Text>
                :
                <div>
                  <Title>
                    {" "}
                    ${parseInt(coupon_info.metadata?.unit_amount) / 100}
                    <span
                      style={{
                        display: "contents",
                        fontSize: "18px",
                        color: "#000",
                      }}
                    ></span>
                  </Title>
                </div>
              </Col>
              <Col span={6}>
                {" "}
                <Typography.Text>
                  <b>Amount Paid</b>
                </Typography.Text>
                :
                <div>
                  <Title>
                    {" "}
                    ${checkout_info.amount_total / 100}
                    <span
                      style={{
                        display: "contents",
                        fontSize: "18px",
                        color: "#000",
                      }}
                    ></span>
                  </Title>
                </div>
              </Col>
            </Row>
            <Typography.Text>
              <b>
                {" "}
                <ClockCircleOutlined /> Created_at{" "}
              </b>
            </Typography.Text>
            :{" "}
            <Tag color="default">
              {moment(coupon_info.created * 1000).format("DD MMM YYYY")}
            </Tag>

            {(props.is_redeemed == true ? <>  <Typography.Text>
              <b>
                {" "}
                <ClockCircleOutlined /> Subscription Status
              </b>
            </Typography.Text>
            : <b>{props.subscription_status === "active" ? (
                <Tag icon={<CheckCircleOutlined />} color="green">
                  Active
                </Tag>
              ) : props.subscription_status === "canceled" ? (
                <Tag icon={<CloseCircleOutlined />} color="red">
                  <Popover content={subscription_info} title="Subscription Status"><b>{props.subscription_status}</b></Popover>
                </Tag>
              ) : props.subscription_status === "expired" ? (
                <><Tag icon={<CloseCircleOutlined />} color="#ccc">
                  Expired
                </Tag> &nbsp; </>
              ) :  props.subscription_status === "grace_period" ? (
                
                <><Tag icon={<FieldTimeOutlined  style={{fontSize:"18px"}} />} color="default">
                      <Badge status="processing" color="red" text="" />   Grace Period
                </Tag>
            
  </>

              ) : ( 
                <Tag icon={<InfoCircleOutlined />} color="processing">
                  {props.subscription_status}
                </Tag>
              )} </b>
 </> : " ")}
           
{total_details.amount_discount ?  
 <Tag icon={<BookOutlined />} color="processing">
                  {(total_details.amount_discount / checkout_info.amount_subtotal *100).toFixed(0)} % Discount Applied
                </Tag> : "" }

                {total_details.amount_shipping ?  
 <Tag icon={<TruckOutlined />} color="green">
                  ${(total_details.amount_shipping / 100)}  Shipping Cost
                </Tag> : "" }

           
          </List.Item>
        </List>
      </Content>
    </PageHeader>
    // </Badge.Ribbon>
  );
};
export default StripeGifts;
